<template>
  <a
    class="icon-button x-link-active"
    :class="{
      active: active
    }"
    @click="handleClick"
  >
    <div class="icon-container">
      <slot name="icon">
        <img
          v-if="active"
          :src="activeImgSrc"
        >
        <img
          v-else
          :src="imgSrc"
        >
      </slot>
    </div>
    <slot />
  </a>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    // active 状态 img 地址
    activeImgSrc: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick () {
      if (this.href) {
        location.href = this.href
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
.icon-button {
  display: block;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  white-space: nowrap;

  .icon-container {
    margin-bottom: 4px;
  }

  img {
    height: 16px;
  }
}
</style>
